import { z } from 'zod';
/**
 * `ask` shows as Ask first: Via asks every time before the action.
 * `never` shows as Don't allow: Via won't do it at all; the user still can.
 */
const viaControlChoiceSchema = z.enum(['ask', 'never']);
/** The actions Via asks about in every chat. For each, the user chooses whether Via asks first or isn't allowed to. */
export const VIA_CONTROL_ACTIONS = ['publishing', 'deleting', 'access', 'testing'];
// Each choice falls back on its own, so a missing, older or damaged value reads as what Via did before controls.
// Publishing starts on Don't allow: a chat that asks first never could publish.
const choices = {
    publishing: viaControlChoiceSchema.catch('never'),
    deleting: viaControlChoiceSchema.catch('ask'),
    access: viaControlChoiceSchema.catch('ask'),
    testing: viaControlChoiceSchema.catch('ask')
};
/**
 * How much Via may do in one chat. Look: it reads and explains, and changes nothing. Ask: its changes wait for the
 * user. Auto: it edits and saves on its own.
 */
const viaChatLevelSchema = z.enum(['look', 'ask', 'auto']);
const storedControlsSchema = z.object({ startIn: viaChatLevelSchema.catch('ask'), ...choices });
export const DEFAULT_VIA_CONTROLS = storedControlsSchema.parse({});
/**
 * What a user keeps for every chat: their choice for each of the four actions, and the level a new chat starts in.
 * Anything that isn't controls at all reads as the defaults, so reading a stored value never fails.
 */
export const viaControlsSchema = storedControlsSchema.catch(DEFAULT_VIA_CONTROLS);
/** What one request carries: the four choices, and whether the chat is Look only. Whether it asks is still its mode. */
export const viaRequestControlsSchema = z.object({ lookOnly: z.boolean().catch(false), ...choices });
//# sourceMappingURL=controls.js.map